import {
    useContext, useEffect, useState
} from 'react';
import {
    Context
} from 'shared/context/GlobalState';
import ProfileCard from 'features/organizations/profile/ProfileCard';
import {
    NestedPageLayout
} from 'shared/components/NewDesignComponents/PageLayout';
import ApiKeyManager from 'features/organizations/profile/apiKeyManager';
import {
    apiKeyService
} from 'shared/api';

export default function Profile() {

    const {
        user, addNewNotifcation
    } = useContext(Context);
    const [apiKeys, setApiKeys] = useState([]);
    const [loading, setLoading] = useState(true);
    const [btnLoading, setBtnLoading] = useState(false);

    useEffect(() => {
        apiKeyService.listApiKeys('user', user._id)
            .then((res) => {
                setApiKeys(res.data);
            })
            .catch(() => {

            }).finally(() => {
                setLoading(false);
            });

    }, []);

    const handleOnSubmit = async (value) => {
        // check required fields
        if (!value.name || !value.url || !value.apiKey || !value.projectId) {
            throw new Error('Please fill all the fields');
        }
        const apiKeyObj = {
            name: value.name,
            url: value.url,
            apiKey: value.apiKey,
            projectId: value.projectId,
            levelType: 'user',
            levelId: user._id,
            apiType: 'IBM'
        };
        setBtnLoading(true);
        try {
            const apiKey = apiKeys.find((key) => key.apiType === 'IBM');
            let res;
            // check if update or create new
            if (apiKey && apiKey._id) {
                apiKeyObj.apiKeyId = apiKey._id;
                delete apiKeyObj.apiType;
                res = await apiKeyService.updateApiKeys(apiKeyObj);
                setApiKeys((prev) => prev.map((item) => (item._id === value._id ? res.data : item)));
                addNewNotifcation('API Key updated successfully', 'success');
            } else {
                res = await apiKeyService.createNewApiKey(apiKeyObj);
                setApiKeys((prev) => [...prev, res.data]);
                addNewNotifcation('API Key created successfully', 'success');
            }
        } catch (err) {

            addNewNotifcation('Something went wrong. Please try again', 'danger');
        } finally {
            setBtnLoading(false);
        }
    };

    const handleOnDelete = async (value) => {
        const apiKeyDeleteObj = {
            byoKeyId: value._id,
            levelType: 'user',
            levelId: user._id,
        };

        try {
            await apiKeyService.deleteApiKeys(apiKeyDeleteObj);
            setApiKeys((prev) => prev.filter((item) => item._id !== value._id));
        } catch (err) {
            if (err.response?.status === 409) {
                addNewNotifcation('API Key is in use. Please remove it from all channels before deleting', 'danger');
            }

        }
    };

    return (
        <NestedPageLayout>
            <div className='flex flex-grow flex-col'>
                <ProfileCard name={user.name} email={user.email} />
            </div>

            <div className='flex flex-grow flex-col mt-4'>
                {loading ? (<h1> loading </h1>) : (
                    <ApiKeyManager
                        loading={btnLoading}
                        onSubmit={handleOnSubmit}
                        apiKeys={apiKeys}
                        onDelete={handleOnDelete}
                    />
                )}
            </div>
        </NestedPageLayout>
    );
}